import React from 'react'
import { HeaderComponent } from './styled'

export const Header = ({ children, style }) => {
	return <HeaderComponent style={style}>{children}</HeaderComponent>
}
